import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-666d6c99")

_pushScopeId("data-v-666d6c99")
const _hoisted_1 = { class: "ui__comTitle_main" }
const _hoisted_2 = { class: "ui__comTitle_left" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "title_line"
}
const _hoisted_5 = {
  key: 1,
  class: "ui__comTitle_right"
}
const _hoisted_6 = { class: "ui__comTitle_model" }
const _hoisted_7 = { class: "ui__comTitle_model_title" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 检测标准说明 ")
const _hoisted_9 = { class: "ui__comTitle_model_head" }
const _hoisted_10 = {
  key: 0,
  class: "ui__comTitle_model_cnt"
}
const _hoisted_11 = {
  key: 0,
  class: "prop_up_height"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 1,
  class: "ui__comTitle_model_cnt"
}
const _hoisted_14 = {
  key: 0,
  class: "prop_up_height"
}
const _hoisted_15 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.state.title) + " ", 1),
      (_ctx.state.title !== '基础信息' && _ctx.state.title !== '委托检测项')
        ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.state.listSumNumber) + "项", 1))
        : _createCommentVNode("", true),
      (!_ctx.state.data.clickFun)
        ? (_openBlock(), _createBlock("div", _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    (_ctx.state.data.clickFun)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "ui__comTitle_right",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickFun && _ctx.clickFun(...args)))
        }, [
          (_ctx.state.data.icon)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: require('../../../assets/image/' + _ctx.state.data.icon)
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createVNode("span", null, _toDisplayString(_ctx.state.data.text), 1)
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_5, [
          (_ctx.state.data.icon)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: require('../../../assets/image/' + _ctx.state.data.icon)
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createVNode("span", null, _toDisplayString(_ctx.state.data.text), 1)
        ])),
    _withDirectives(_createVNode("div", {
      class: "ui__comTitle_model_cover",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hiddenModel && _ctx.hiddenModel(...args)))
    }, null, 512), [
      [_vShow, _ctx.state.isShowModel]
    ]),
    _withDirectives(_createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("img", {
          src: require('../../../assets/image/close.png'),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hiddenModel && _ctx.hiddenModel(...args)))
        }, null, 8, ["src"])
      ]),
      _createVNode("div", _hoisted_9, _toDisplayString(_ctx.state.title), 1),
      (_ctx.state.channelType === 'lingshou')
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.text.slice(0,1), (item, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                (item === 'prop_up_height')
                  ? (_openBlock(), _createBlock("div", _hoisted_11))
                  : (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(item), 1))
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_13, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.text, (item, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                (item === 'prop_up_height')
                  ? (_openBlock(), _createBlock("div", _hoisted_14))
                  : (_openBlock(), _createBlock("div", _hoisted_15, _toDisplayString(item), 1))
              ]))
            }), 128))
          ]))
    ], 512), [
      [_vShow, _ctx.state.isShowModel]
    ])
  ]))
})